/**
 * Created by borunski on 21.09.16.
 */
const options = {
    rootClass: 'zp_parallax_slider_element'
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);

    class ParallaxSliderElement {


        constructor(root) {
            this.start(root);
            this.initEvents(root);
            // this.adjustBackgroundSize(root);
        }

        start(root) {

            let scalarX = root.data( "scalar-x" );
            let scalarY = root.data( "scalar-y" );
            if ($('html').hasClass('zp-touch')) {
                scalarX *= 2;
                scalarY *= 2;
            }
            let originY = root.data( "origin-y" );

            const parallaxDirection = root.data( "parallax-direction" );
            if (parallaxDirection == "true" || parallaxDirection == true)
                originY = 0;

            const frictionX = 0.2;
            const frictionY = 0.2;

            let rootId = root[0].id;
            let parallaxContainer = document.getElementById(rootId+'_container');

            let scene = parallaxContainer;
            let parallax = new Parallax(scene, {
                calibrateX: true,
                calibrateY: true,
                invertX: parallaxDirection,
                invertY: parallaxDirection,
                limitX: true,
                limitY: true,
                scalarX: scalarX,
                scalarY: scalarY,
                frictionX: frictionX,
                frictionY: frictionY,
                originX: 0.5,
                originY: originY
            });

            // root.imagesLoaded( () => {
            //
            // });

            // var $element = jQuery(element);
            // var background = $element.children()
            // background.css('background-position', 'calc(50% + '+x+') calc(50% + '+y+')')
            // background.css('right', x)
            // background.css('bottom', y)

        }

        initEvents(root) {

            // _w.on('scroll', () => {
            //
            // });

            // _w.on('resize', () => {

                // this.adjustBackgroundSize(root);


                //TODO

                // let imagesLoaded = $('.zp_parallax_slider_additional_image_link');
                //
                // let imageWidth = image.width();
                // let imageHeight = image.height();
                // let imagePositionRight = 10;
                // let imagePositionTop = 10;
                //
                // const aspectRatio = imageWidth / imageHeight;
                //
                // let wi = 0,
                //     hi = 0;
                // let r = background.width() / background.height();
                // if (aspectRatio <= r) {
                //     wi = background.width();
                //     hi = background.width() / aspectRatio;
                // } else {
                //     wi = background.height() * aspectRatio;
                //     hi = background.height();
                // }
                // let offsetTop = (hi - background.height()) / 2;
                // let offsetRight = (wi - background.width()) / 2;
                //
                // let xl = (wi * imagePositionRight) / imageWidth;
                // let yl = (hi * imagePositionTop) / imageHeight;
                //
                // image.css({
                //     top: yl - offsetTop,
                //     left: xl - offsetRight,
                // });

                // let slideElement = $('#' + root.attr('id') + '.zp_parallax_slider_element');


                // let imageLink = $('#' + root.attr('id') + ' .zp_parallax_slider_additional_image_link');
                // let windowWidth = window.innerWidth;
                // let windowHeight = window.innerHeight;
                // let backgroundWidth = 2000;
                // let backgroundHeight = 1497;
                // let imageWidth = 239;
                // let imageHeight = 239;
                //
                // if (windowWidth < imageWidth) {
                //
                //     imageLink.css({
                //         transform: 'translate(0, 0) scale()'
                //     })
                //
                // }
                // let additionalImage = {
                //     x: 200,
                //     y: 200,
                //     width: 239,
                //     height: 239
                // };
                //
                // const aspectRatio = imageWidth / imageHeight;
                //
                // imageLink.remove();
                //
                // let wi = 0,
                //     hi = 0;
                // let r = window.innerWidth / window.innerHeight;
                // if (aspectRatio <= r) {
                //     wi = window.innerWidth;
                //     hi = window.innerWidth / aspectRatio;
                // } else {
                //     wi = window.innerHeight * aspectRatio;
                //     hi = window.innerHeight;
                // }
                // let offsetTop = (hi - window.innerHeight) / 2;
                // let offsetLeft = (wi - window.innerWidth) / 2;
                //
                // let xl = (wi * additionalImage.x) / imageWidth;
                // let yl = (hi * additionalImage.y) / imageHeight;
                //
                // imageLink.css({
                //     top: yl - offsetTop,
                //     right: xl - offsetLeft,
                // });
                // slideElement.append(imageLink);

                //TODO

            // });

            // _w.on('click', () => {
            //
            // });
            //
            // _w.on('mousemove', (event) => {
            //
            //     let _parallaxContainerLayer = $('#' + root.attr('id') + '_container .layer');
            //     let regExp = /matrix\(\d, \d, \d, \d, \d.\d, \d.\d\)/;
            //
            //     console.log(_parallaxContainerLayer.css('transform'));
            //     console.log(_parallaxContainerLayer.css('transform').match(regExp));
            //
            //
            // });

        }

        adjustBackgroundSize (root) {

            let scalarX = root.data( "scalar-x" );
            let scalarY = root.data( "scalar-y" );
            if ($('html').hasClass('zp-touch')) {
                scalarX *= 2;
                scalarY *= 2;
            }

            const parallaxDirection = root.data( "parallax-direction" );
            let rootId = root[0].id;
            let parallaxContainer = document.getElementById(rootId+'_container');
            let _parallaxContainerLayer = $('#' + root.attr('id') + '_container .layer');
            let _parallaxContainerLayerContent = $('#' + root.attr('id') + '_container .layer .zp_parallax_slider_container_content');

            let depths = [];
            _parallaxContainerLayer.each( (index) => {
                let depth = $(_parallaxContainerLayer[index]).data( "depth" );
                depths.push(depth);
            });

            let maxLayerDepth = Math.max.apply(null, depths);

            let maxParallaxWidth = Math.ceil((parallaxContainer.getBoundingClientRect().width * (scalarX/100)) * maxLayerDepth);
            let maxParallaxHeight = Math.ceil((parallaxContainer.getBoundingClientRect().height * (scalarY/100)) * maxLayerDepth);

            _parallaxContainerLayerContent.css({
                width: 'calc(100% + '+(maxParallaxWidth*2)+'px)',
                right: maxParallaxWidth,
                height: 'calc(100% + '+(maxParallaxHeight*2)+'px)',
                bottom: maxParallaxHeight
            });

        }

    }

    return ParallaxSliderElement;

}(window, document, jQuery)));